<template>
  <el-dialog
    id="create-modal"
    class="form-modal"
    :visible.sync="createCardVisible"
    v-loading="createCardProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Create Card Account</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="createCardOperation">Create</el-button>
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
          >
            Cancel
          </el-button
          >
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          />
        </div>
      </div>
    </div>

    <el-form>
      <div class="inline-form-group" v-if="true">
        <el-checkbox
          v-model="createCardForm.default"
          style="margin-left: 0;"
        >
          Make Primary
        </el-checkbox>
      </div>
      <div class="inline-form-group">
        <el-col :span="11">
          <el-input v-model="createCardForm.name" placeholder="Card Name">
            <template slot="prefix">Card Name</template>
          </el-input>
        </el-col>
        <el-col :span="1" />
        <el-col :span="12">
          <el-input v-model="createCardForm.number" type="password" placeholder="Card Number">
            <template slot="prefix">Card Number</template>
          </el-input>
        </el-col>
      </div>

      <div class="inline-form-group">
        <el-col :span="11">
          <el-select v-model="createCardForm.expMonth" placeholder="Exp. Month">
            <template slot="prefix">Exp. Month</template>
            <el-option
              v-for="(item, index) in monthOptions"
              :key="index"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-col>
        <el-col :span="1" />
        <el-col :span="6">
          <el-select v-model="createCardForm.expYear" placeholder="Exp. Year">
            <template slot="prefix">Exp. Year</template>
            <el-option
              v-for="(item,index) in yearOptions"
              :key="index"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-col>
        <el-col :span="1" />
        <el-col :span="5">
          <el-input v-model="createCardForm.cvc" placeholder="CVC">
            <template slot="prefix">CVC</template>
          </el-input>
        </el-col>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>

import DadsSelect from "@/components/select";
import moment from 'moment-timezone';

export default {
  name: "CardCreateForm",

  props: {
    createCardVisible: {required: true},
    clearFormFields: {required: true},
    createCardProcessing: {required: true}
  },

  components: {
    DadsSelect,
  },

  data() {
    return {
      monthOptions: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
      yearOptions: [],
      createCardForm: {
        number: "",
        expMonth: "",
        expYear: "",
        cvc: "",
        name: "",
        default: false,
        accountNumber: "",
        routingNumber: "",
        paymentType: "card"
      },
    };
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    }
  },

  methods: {
    createCardOperation() {

      const { valid, error } = this.validateFields();

      if(!valid){
        this.$notify({
          title: 'Invalid data',
          message: error,
          type: 'error'
        })
        return;
      }

      const createBody = {...this.createCardForm};
      this.$emit("createCardOperation", createBody);
    },

    cancelOperation() {
      this.clearFields();
      this.$emit("cancelOperation", "create");
    },

    validateFields() {

      const { number, expMonth, expYear, cvc, name } = this.createCardForm;
      let response = {valid: true, error: null};
      const rules = [
        {
          valid: number.length > 0,
          message: 'Card number cannot be empty'
        },
        {
          valid: this.monthOptions.includes(expMonth),
          message: 'Select a valid expiration month'
        },
        {
          valid: expYear.length === 4,
          message: 'Select a valid year'
        },
        {
          valid: cvc.length > 0 && cvc.length < 5,
          message: 'Enter a valid CVC code'
        },
        {
          valid: name.length > 0,
          message: 'Name cannot be empty'
        }
      ]

      for(let item of rules){
        if(!item.valid){
          response = {
            valid: false,
            error: item.message
          }
          break;
        }
      }

      return response;

    },

    clearFields() {
      this.createCardForm = {
        number: "",
        expMonth: "",
        expYear: "",
        cvc: "",
        name: "",
        default: false,
        paymentType: "card"
      };
    }
  },
  mounted() {

    let years = [];
    for(let i = 0; i < 15; i++) {
      years.push(moment().add(i, 'years').format('YYYY'))
    }
    this.yearOptions = years;
  }
};
</script>
